export enum ErrorMessages {
  InvalidNumberOfKeys = 'Must be a number between 1 and the number of available keys',
  UnexpectedError = 'An unexpected error has occurred. Please try again later.'
}
